import { Component, ElementRef, HostListener, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { CoursesService } from 'src/providers/courses.service';
import { DashboardService } from 'src/providers/dashboard.service';
import { LoginService } from 'src/providers/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as AOS from "aos";
import {  VideoPlayerDialog } from '../home/home.component';
import { ThanksDialogueComponent } from '../thanks-dialogue/thanks-dialogue.component';
import { JSONIDService } from 'src/providers/schema';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
// import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT } from 'ngx-lightbox';
import { GalleryDialog } from '../home-latest/home-latest.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-agra',
  templateUrl: './agra.component.html',
  styleUrls: ['./agra.component.scss']
})


export class AgraComponent implements  OnInit {


  coursesArray: any[] = [];

  toppers2024: any[]  = [
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-1.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-02.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-03.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-04.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-05.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-06.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-07.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-08.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-09.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-10.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-11.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-12.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-13.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-14.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-15.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-16.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-17.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-18.webp',
  ]

  toppersImg: any[] = [{
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/kapil.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/pranav.jpeg',
  },
  {
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/atish.jpeg',
  },
  {
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/harkiran.jpeg',
  },
  {
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/geet.jpeg',
  }, {
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/pavan.jpg',
  }, {
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/tanya.jpeg',
  }, {
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/adarsh.jpeg',
  }, {
    img: 'https://media.iquanta.in/ui_images/cat-2024-new/vaibhav.jpeg'
  },
  ]

  Sessionslist1: any[] = [
    {
      img: 'https://media.iquanta.in/ui_images/geetprofile.jpeg',
      // title:'CAT 2023 Strategy & Details',
    },
    {
      img: 'https://media.iquanta.in/ui_images/cat-2024-new/Low-percentile-2.jpg',
      // title:'CAT Geometry Problem Solving',
    },
    {
      img: 'https://media.iquanta.in/ui_images/cat-2024-new/Low-percentile-1.jpg',
      // title:'CAT 2023 Strategy & Details',
    },


    {
      img: 'https://media.iquanta.in/ui_images/anubhavprofile.jpeg',
      // title:'CAT 2023 Strategy & Details',
    },
    {
      img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2023-02-03+at+10.32.01+AM+(2).jpeg',
      // title:'CAT 2023 Strategy & Details',
    },
    {
      img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/Shubhashish+95_ile.jpeg'
    },
    {
      img: 'https://media.iquanta.in/ui_images/harshitprofile.jpeg'
    }
  ]

  successStories: any[] = [{
    img: 'https://media.iquanta.in/ui_images/gursimranprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/aayishrofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/karalprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/avinashprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/shubashishprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/biswaruoprofile.jpeg'
  },
  {
    img: 'https://media.iquanta.in/ui_images/gautamprofile.jpeg'
  }]

  slickInit(e: any) {
  }

  breakpoint(e: any) {
  }

  afterChange(e: any) {
  }

  beforeChange(e: any) {
  }



  strategyTab: any = 0;

  slideConfig = {
    "slidesToShow": 2, "slidesToScroll": 2,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    // autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]



  };

  slideConfig1 = {
    "slidesToShow": 3, "slidesToScroll": 3,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    // autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]



  };

  slideConfig3 = {
    "slidesToShow": 4, "slidesToScroll": 4,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="bi bi-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="bi bi-chevron-right"></i></button>',
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]



  };

  gotoLink(link: any) {
    window.open(link, '_blank')
  }

  singleGallery(){
    const dialogref = this.dialog.open(GalleryDialog, {
      width: 'auto',
      panelClass: 'gallery-dilogue',
      data: { index: 0, images: [{img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_190781004_484934279394175_8324459811870473182_n+(1).jpg' }]}
    })
    dialogref.afterClosed().subscribe(result => {

    })
  
  }

  gotocourses(ev: any) {
    var elmnt: any = document.getElementById("courses");
    elmnt.scrollIntoView();
  }

  getCourses() {
    this.coursesArray = [];
    this.coursesService.getPagewiseCourses('Agra', 'landingpage', '2024').subscribe(res=>{
      if(res.success){
        if(res.data.length > 0){
          this.coursesArray = res.data[0].course.filter((x:any)=> !x.is_rq);
        }
      }
        })
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    let div1: any = document.getElementById('cat-journey');
    const viewportOffset1 = div1.getBoundingClientRect();
    const top1 = viewportOffset1.top;
    if (top1 < 100) {
      this.activeFooterTab = 'cat-journey';
    }

    let div2: any = document.getElementById('success-stories');
    const viewportOffset2 = div2.getBoundingClientRect();
    const top2 = viewportOffset2.top;
    if (top2 < 100) {
      this.activeFooterTab = 'success-stories';
    }

    let div6: any = document.getElementById('courses');
    const viewportOffset6 = div6.getBoundingClientRect();
    const top6 = viewportOffset6.top;
    if (top6 < 100) {
      this.activeFooterTab = 'courses';
    }

    let div3: any = document.getElementById('syllabus');
    const viewportOffset3 = div3.getBoundingClientRect();
    const top3 = viewportOffset3.top;
    if (top3 < 100) {
      this.activeFooterTab = 'syllabus';
    }

    let div4: any = document.getElementById('strategy');
    const viewportOffset4 = div4.getBoundingClientRect();
    const top4 = viewportOffset4.top;
    if (top4 < 100) {
      this.activeFooterTab = 'strategy';
    }

    let div5: any = document.getElementById('resources');
    const viewportOffset5 = div5.getBoundingClientRect();
    const top5 = viewportOffset5.top;
    if (top5 < 100) {
      this.activeFooterTab = 'resources';
    }

    let div7: any = document.getElementById('toppers-feedback');
    const viewportOffset7 = div7.getBoundingClientRect();
    const top7 = viewportOffset7.top;
    if (top7 < 100) {
      this.activeFooterTab = 'toppers-feedback';
    }

    let div8: any = document.getElementById('milestone1')
    const viewportOffset8 = div8.getBoundingClientRect();
    const top8 = viewportOffset8.top;

    if (top8 > 0) {
      let li: any = document.getElementById('now')
      li.classList.add('active')
    } else {
      let li: any = document.getElementById('now')
      li.classList.remove('active')
    }

    let div9: any = document.getElementById('milestone2')
    const viewportOffset9 = div9.getBoundingClientRect();
    const top9 = viewportOffset9.top;
    if (top9 > 0 && top9 < 150) {
      let li: any = document.getElementById('june')
      li.classList.add('active')
    } else {
      let li: any = document.getElementById('june')
      li.classList.remove('active')
    }

    let div10: any = document.getElementById('milestone3')
    const viewportOffset10 = div10.getBoundingClientRect();
    const top10 = viewportOffset10.top;
    if (top10 > 0 && top10 < 230) {
      let li: any = document.getElementById('july')
      li.classList.add('active')
    } else {
      let li: any = document.getElementById('july')
      li.classList.remove('active')
    }

    let div11: any = document.getElementById('milestone4')
    const viewportOffset11 = div11.getBoundingClientRect();
    const top11 = viewportOffset11.top;
    if (top11 > 0 && top11 < 330) {
      let li: any = document.getElementById('oct')
      li.classList.add('active')
    } else {
      let li: any = document.getElementById('oct')
      li.classList.remove('active')
    }

    let div12: any = document.getElementById('milestone5')
    const viewportOffset12 = div12.getBoundingClientRect();
    const top12 = viewportOffset12.top;
    if (top12 > 0 && top12 < 330) {
      let li: any = document.getElementById('nov')
      li.classList.add('active')
    } else {
      let li: any = document.getElementById('nov')
      li.classList.remove('active')
    }

    let div13: any = document.getElementById('navbar')
    const viewportOffset13 = div13.getBoundingClientRect();
    const top13 = viewportOffset13.top;
    if (top13 < 113) {
      div13.classList.add('fixed')
    }

    var h: any = document.documentElement;
    var b: any = document.body;;
    var scrollTop: any = 'scrollTop';
    var scrollHeight: any = 'scrollHeight';
    let scrolval: any = (h[scrollTop] || b[scrollTop]) / ((h[scrollHeight] || b[scrollHeight]) - h.clientHeight) * 100;


    if (scrolval > 53 && scrolval < 58) {
      this.timelineTab = 'now';
    } else if (scrolval > 58 && scrolval < 60) {
      this.timelineTab = 'june';
    } else if (scrolval > 60 && scrolval < 61.5) {
      this.timelineTab = 'july';
    } else if (scrolval > 61.5 && scrolval < 62.2) {
      this.timelineTab = 'oct';
    } else if (scrolval > 62.2) {
      this.timelineTab = 'nov';
    }

  }

  timelineTab: any;


  gotocourse() {
    var elemnt: any = document.getElementById('courses')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }

  enquiryForm() {
    const dialog = this.dialog.open(StepFourDialog1, {
      width: '390px',
      panelClass: ['cat-new-form'],
      data: 'Agra'
    })

    dialog.afterClosed().subscribe((result: any) => {
      if (result.success) {
      
      }
    })
  }

  getProfileData() {
    this.loginService.profileData.subscribe(res => {
      this.token = this.sessionStorage.getItem('usertoken');
      if (this.sessionStorage.getItem('userData')) {
        this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
      } else {
        this.userData = '';
        this.token = ''
      }
    })
  }

  

  activeFooterTab: any = 'cat-journey';


  goToSection(val: any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
    this.activeFooterTab = val;
  }

  galleryopen(index: any, imgList: any) {
    const dialogref = this.dialog.open(GalleryDialog, {
      width: 'auto',
      panelClass: 'gallery-dilogue',
      data: { index: index, images: imgList}
    })
    dialogref.afterClosed().subscribe(result => {

    })
   
  }


  Sessionslist2: any[] = [
    {
      img: 'https://media.iquanta.in/ui_images/ayushprofile.jpeg',
      // title:'CAT 2023 Strategy & Details',
    },
    {
      img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_190781004_484934279394175_8324459811870473182_n+(1).jpg',
      // title:'CAT Geometry Problem Solving',
    }
  ]


  constructor(
    public dialog: MatDialog, 
    public coursesService: CoursesService, 
    public matSnackbar: MatSnackBar, 
    // public _lightbox: Lightbox,
    private titleService: Title, 
    private metaService: Meta, 
    public NagpurService: JSONIDService, 
    @Inject(DOCUMENT) private dom: any, 
    @Inject(LOCAL_STORAGE) public sessionStorage: any, 
    public loginService: LoginService, 
    public elementRef: ElementRef) {
    AOS.init();
  }

  playVideo1() {
    const dialogref = this.dialog.open(VideoPlayerDialog, {
      width: '800px',
      data: { video: 'https://www.youtube.com/embed/yJVBnqDKIR4?rel=0', type: 'toppers' },
      panelClass: ['video-dialog', 'video-dilogue2']
    })
    dialogref.afterClosed().subscribe(result => {

    })
  }

  stepFourCard: boolean = false;
  selectedIndex: any = 1;

  json1:any;
  token: any;
  userData: any;
  ngOnInit(): void {
    this.json1 = this.NagpurService.Agra;

   // Meta Data
   this.titleService.setTitle("Best CAT Coaching in Agra 2024 - iQuanta");
   this.metaService.updateTag( 
   { name: 'description', content: "Discover the best CAT coaching in Agra to boost your MBA entrance exam preparation. Our expert faculty, comprehensive study materials, and proven track record of success ensure you achieve top scores."}); 
   this.metaService.updateTag( 
   { name: 'keywords', content: 'Best CAT Coaching in Agra,best coaching for cat in Agra,cat best coaching in Agra,best coaching in Agra for cat,cat coaching in Agra,cat preparation in Agra,cat classes in Agra,mba coaching in Agra' });
// Canonical Link
   const head = this.dom.getElementsByTagName('head')[0];
   var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
   head.appendChild(element);
   element.setAttribute('rel', 'canonical')
   element.setAttribute('href', 'https://www.iquanta.in/offline-center/agra')
// Facebook
   this.metaService.updateTag(
     { property: 'og:type', content: "website" })
   this.metaService.updateTag(
     { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
   this.metaService.updateTag(
     { property: 'og:title', content: "Best CAT Coaching in Agra 2024" })
   this.metaService.updateTag(
     { property: 'og:url', content: 'https://www.iquanta.in/offline-center/agra' })
   this.metaService.updateTag(
     { property: 'og:description', content: "Discover the best CAT coaching in Agra to boost your MBA entrance exam preparation. Our expert faculty, comprehensive study materials, and proven track record of success ensure you achieve top scores." });
   this.metaService.updateTag(
     { property: 'og:image:height', content: '758' })
   this.metaService.updateTag(
     { property: 'og:image:width', content: '1600' })
   this.metaService.updateTag(
     { property: 'og:image:type', content: 'image/jpeg' })
   this.metaService.updateTag(
     { property: 'og:image', content: 'https://media.iquanta.in/ui_images/CAT-2024.jpeg' })
// Article Publish Time
   this.metaService.updateTag(
     { property: 'article:published_time', content: '2024-03-04T11:10:42+00:00' })
   this.metaService.updateTag(
     { property: 'article:modified_time', content: '2024-09-10T10:10:42+00:00' })
// Twitter
   this.metaService.updateTag(
     { property: 'twitter:label2', content: "Est. reading time" })
   this.metaService.updateTag(
     { property: 'twitter:data2', content: "6 Minutes" })
   this.metaService.updateTag(
     { property: 'twitter:title', content: "Best CAT Coaching in Agra 2024" })
   this.metaService.updateTag(
     { property: 'twitter:url', content: 'https://www.iquanta.in/offline-center/agra' })
   this.metaService.updateTag(
     { property: 'twitter:description', content: "Discover the best CAT coaching in Agra to boost your MBA entrance exam preparation. Our expert faculty, comprehensive study materials, and proven track record of success ensure you achieve top scores." });
   this.metaService.updateTag(
     { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/CAT-2024.jpeg' })
   this.metaService.updateTag(
     { property: 'twitter:image:height', content: '758' })
   this.metaService.updateTag(
     { property: 'twitter:image:type', content: 'image/jpeg' })
   this.metaService.updateTag(
     { property: 'twitter:image:width', content: '1600' })
      
    this.getCourses()
    this.token = this.sessionStorage.getItem('usertoken');
    if (this.token) {
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));

    }
    this.getProfileData()
  }

  ngAfterViewInit() {
    // this.iniSlickJs()
  }


  iniSlickJs() {
    const htmlScriptElement = document.createElement('script');
    htmlScriptElement.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js';
    this.elementRef.nativeElement.appendChild(htmlScriptElement);
    const htmlScriptElement1 = document.createElement('script');
    htmlScriptElement1.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js';
    this.elementRef.nativeElement.appendChild(htmlScriptElement1);
  }
}


@Component({
  selector: 'app-step-four',
  templateUrl: './step-four.html',
  styleUrls: ['../cat-test/cat-test.component.scss']
})

export class StepFourDialog1 {
  counsellingForm!: FormGroup;
  token:any;
  userData:any;
  constructor(public dialogRef: MatDialogRef<StepFourDialog1>, public formBuilder: FormBuilder, public coursesService: CoursesService,
    public dialog: MatDialog, public snackBar: MatSnackBar, public dashboardService: DashboardService, 
    @Inject(MAT_DIALOG_DATA) public data:any, @Inject(LOCAL_STORAGE) public sessionStorage: any, 
     public deviceService: DeviceDetectorService, @Inject(DOCUMENT) public doc:any) {
    this.counsellingForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
      mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      year: ['', Validators.required],
    })
    this.token = this.sessionStorage.getItem('usertoken');
    if (this.token) {
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));

    }
  }

  examList:any[]=['CAT', 'GDPI', 'GMAT', 'XAT', 'CMAT', 'MICAT']
  examList1:any[]=['CUET UG', 'CUET PG', 'IPMAT', 'CLAT', 'IIT']

  getExamCategory(){
    let category:any;
    // this.counsellingForm.value.course.forEach((course:any)=>{
      if(this.examList.includes(this.counsellingForm.value.course)){
        category = 'MBA'
      }else{
        category = 'After 12th'
      }
    // })
    return category;
  }

  addInternalCRMLead() {
    // if(this.token){
      let medium: any;
    let source: any;
    let campaign: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
        if (item.includes('utm_source')) {
          source = item.split('=')[1]
        }
        if (item.includes('utm_campaign')) {
          campaign = item.split('=')[1]
        }
      })
    }
      let reqObj = {
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId": this.userData ? this.userData.id : 9999,
        "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
        "firstName": this.counsellingForm.value.name,
        "name": this.counsellingForm.value.name,
        "countryCode": 91,
        "phone": this.counsellingForm.value.phone,
        "email": this.counsellingForm.value.email,
        "source": "Website",
        "medium": this.data,
        "campaign": "Roadmap Get Counselling",
        "pageLocation": 'Offline Center - '+this.data,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.doc.URL,
        "registrationDevice": this.deviceService.deviceType,
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        "customFields": {
          "exam": 'CAT',
          "examCategory": 'MBA',
          "examTargetYear": this.counsellingForm.value.year,
        "leadPriority": "Platinum",

        },
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
    "pageLocation": this.doc.URL,
            "source": "Website",
        "medium": this.data,
        "campaign": "Roadmap Get Counselling",
            adContent: "",
    
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
          },
        ],
      }
  
      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
  
        }
      })
    // }
  }

  addNPF() {
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.counsellingForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.counsellingForm.value.mobile,
      "email": this.counsellingForm.value.email,
      "field_gender": '',
      "field_exam_category": 'MBA',
      "field_course_year": this.counsellingForm.value.year,
      "field_exam": 'CAT',
      "source": "Website",
      "medium": this.data,
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      this.counsellingForm.reset()
      this.dialogRef.close(res)
    })
  }

  submit() {

    if (this.counsellingForm.valid) {
      let reqObj = {
        name: this.counsellingForm.value.name,
        email: this.counsellingForm.value.email,
        phone_no: this.counsellingForm.value.mobile,
        course: 'CAT',
        year: this.counsellingForm.value.year,
        time_slot: '',
      }

      this.coursesService.homeEnquiry(reqObj).subscribe(res => {
        if (res.success || res.id) {
          this.addInternalCRMLead()
          const dialogRef = this.dialog.open(ThanksDialogueComponent, {
            width: '330px',
            panelClass: 'thanks-modal'

          })
          dialogRef.afterClosed().subscribe(res => {
            this.addNPF()
          })
          // this.snackBar.open('Thanks for reaching us. Our Team will get back to you shortly', 'OK', {
          //   verticalPosition: 'top',
          //   duration: 3000,
          //   panelClass: 'snack-success'
          // })
          // location.reload()
        } else {
          this.snackBar.open(res.data, 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-error'
          })
        }
      }, err => {
        this.snackBar.open(err.error.error, 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      })
    } else {
      if (this.counsellingForm.controls['name'].hasError('required')) {
        this.snackBar.open('Name is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('required')) {
        this.snackBar.open('Email is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('required')) {
        this.snackBar.open('Phone Number is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['course'].hasError('required')) {
        this.snackBar.open('Course is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['year'].hasError('required')) {
        this.snackBar.open('Target Year is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['email'].hasError('pattern')) {
        this.snackBar.open('Email is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('pattern')) {
        this.snackBar.open('Phone Number is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
    }
  }

  close() {
    this.dialogRef.close()
  }

}

